export default __webpack_public_path__ + "static/media/links-img.7268796b.png";